"use client";

import { RegularPostDrawer } from "@/components/feed/regular-post-drawer/regular-post-drawer.client";
import { useShellProfileData } from "@/hooks/use-shell-profile-data";
import { mediaPreviewUrlFromAsset } from "@/lib/media";

/**
 * "Share to feed" for a sticker: the regular post composer, opened with the
 * sticker already attached. The composer only ever offers stickers the member
 * has unlocked, and the server re-checks on publish.
 */
export function StickerPostComposer({
  open,
  onOpenChange,
  stickerId,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  stickerId: string | null;
}) {
  const me = useShellProfileData().data ?? null;
  if (!me) return null;
  return (
    <RegularPostDrawer
      open={open}
      onOpenChange={onOpenChange}
      initialSticker={stickerId}
      currentUser={{
        id: me.userId,
        displayName: me.fullName ?? "You",
        avatarUrl: mediaPreviewUrlFromAsset(me.images?.[0]) ?? null,
      }}
    />
  );
}
